"use client";

import React from "react";
import TiptapHighlightContent from "@/components/TiptapHighlightContent";

export default function HighlightedText({
  text,
  as = "h1",
  className,
  highlightClassName = "text-primary-200",
  ...rest
}: {
  text: string | object;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "p" | "span";
  className?: string;
  highlightClassName?: string;
}) {
  if (!text) return null;
  if (
    typeof text === "object" ||
    (typeof text === "string" && text.startsWith("{"))
  ) {
    return (
      <TiptapHighlightContent
        content={text}
        as={as}
        className={className}
        highlightClassName={highlightClassName}
        {...rest}
      />
    );
  }

  // Fallback for plain text
  const Element = as;
  return (
    <Element className={className} {...rest}>
      {typeof text === "string" ? text : ""}
    </Element>
  );
}
